/* eslint-disable max-lines */
/* eslint-disable max-len */

export function ContentLocalePl() {
  return (
    <>
      <div>
        <p className="page-title">
          Prohlášení o ochraně osobních údajů web portálu Robotics
        </p>
        <h2 className="heading-title">
          I. Firma a adresa správce a pověřence pro ochranu osobních údajů
        </h2>

        <p className="my-20">Firma a kontaktní údaje správce:</p>

        <p className="my-10">
          Kärcher spol. s r. o., se sídlem č.p. 193, 251 01 Modletice, IČO
          48535761, Tel.: +420323555555, email: info@karcher.cz (dále jen:
          společnost Kärcher) postupuje při všech procesech zpracování osobních
          údajů (např. shromažďování, zpracování a předávání) v souladu se
          zákonnými předpisy.
        </p>

        <p className="my-10">
          Níže uvedené prohlášení vám poskytuje přehled o tom, jaké údaje jsou
          na našem web portálu na adrese&nbsp;
          <a
            href="https://kira-webportal.ipp.kaercher.com/"
            target="_blank"
            rel="noreferrer noopener">
            https://kira-webportal.ipp.kaercher.com/
          </a>
          &nbsp;(dále jen: platforma) a jeho prostřednictvím shromažďovány a
          jakým způsobem jsou zpracovávány, jaká bezpečnostní opatření
          společnost Kärcher za účelem ochrany vašich údajů přijímá a jak můžete
          uplatnit svá práva.
        </p>

        <p className="my-10">
          V případě jakýchkoli dotazů týkajících se ochrany osobních údajů nebo
          vašich práv jako dotčené osoby se můžete obrátit na pověřence pro
          ochranu osobních údajů společnosti Kärcher sídlícího na adrese:
        </p>

        <p>GDPR.COOL s.r.o.</p>
        <p>Pověřenec pro ochranu osobních údajů</p>
        <p>Ovocný trh 8</p>
        <p>110 00 Praha 1</p>
        <p>
          <a href="mailto:milos.snytr@gdpr.cool">milos.snytr@gdpr.cool</a>
        </p>
      </div>

      <div className="mt-40">
        <h2>II. Všeobecné informace ke zpracování osobních údajů</h2>

        <h3>1. Rozsah zpracování osobních údajů</h3>
        <p>
          Není-li uvedeno jinak, zpracováváme vaše osobní údaje jako uživatele
          naší platformy (dále jen: dotčená osoba) v rozsahu blíže
          specifikovaném v tomto dokumentu za tím účelem, abychom vám mohli
          poskytnout funkční a uživatelsky příjemnou platformu a naše příslušné
          služby.
        </p>

        <h3>2. Právní základ pro zpracování osobních údajů</h3>
        <p>
          Pokud si pro procesy zpracování osobních údajů vyžádáme souhlas
          dotčené osoby, slouží jako právní základ čl. 6 odst. 1 písm. a)
          Obecného nařízení o ochraně osobních údajů (dále jen: GDPR). Souhlas
          se zpracováním osobních údajů můžete kdykoliv odvolat. Odvolání vašeho
          souhlasu nemá zpětný účinek a zákonnost zpracování osobních údajů před
          jeho odvoláním jím není dotčena.
        </p>

        <p className="mt-10">
          Při zpracování osobních údajů, které jsou pro používání platformy
          nezbytné, slouží jako právní základ čl. 6 odst. 1 písm. b GDPR, tj.
          zpracování vašich osobních údajů je nezbytné pro splnění smlouvy,
          jejíž jste stranou. Totéž platí i pro procesy zpracování, které jsou
          nezbytné pro provedení předsmluvních opatření.
        </p>

        <p className="mt-10">
          Pokud je zpracování osobních údajů nezbytné ke splnění právní
          povinnosti, jíž naše společnost podléhá, slouží jako právní základ čl.
          6 odst. 1 písm. c) GDPR.
        </p>

        <p className="mt-10">
          Je-li zpracování nezbytné k ochraně oprávněného zájmu naší společnosti
          nebo třetí osoby a nepřevažují-li zájmy, základní práva a základní
          svobody dotčené osoby nad výše uvedeným zájmem, slouží jako právní
          základ pro zpracování čl. 6 odst. 1 písm. f GDPR.
        </p>

        <h3>3. Výmaz dat a doba uchovávání</h3>
        <p>
          Pokud není uvedeno jinak, jsou osobní údaje zablokovány nebo vymazány,
          jakmile účel uchovávání pomine. Zanikne-li některý z výše uvedených
          účelů zpracování vašich osobních údajů, jsme oprávněni vaše údaje dále
          zpracovávat v nezbytném rozsahu, je-li dán jiný účel zpracování vašich
          osobních údajů, v opačném případě vaše osobní údaje vymažeme.
        </p>

        <p className="mt-10">
          V případě získání vašich osobních údajů na základě vámi uděleného
          souhlasu zpracováváme vaše osobní údaje po dobu platnosti tohoto
          souhlasu, případně do okamžiku odvolání vašeho souhlasu. Jsouli vaše
          osobní údaje zpracovávány za účelem plnění smlouvy uzavřené s naší
          společností, jsme oprávněni tyto údaje zpracovávat po dobu trvání
          závazku z této smlouvy. V případě zpracování vašich osobních údajů na
          základě naší zákonné povinnosti zpracováváme tyto údaje po dobu
          vyžadovanou příslušnými právními předpisy. V případě našeho
          oprávněného zájmu zpracováváme osobní údaje po dobu trvání tohoto
          našeho zájmu.
        </p>

        <p className="mt-10">
          Zpracováváme-li vaše osobní údaje z právního důvodu oprávněného zájmu
          a vznesete námitky proti tomuto zpracování, přičemž neexistují žádné
          naše převažující oprávněné důvody pro zpracování, osobní údaje
          vymažeme poté, co vás o tom informujeme.
        </p>

        <p className="mt-10">
          Osobní údaje mohou být kromě toho uchovávány i tehdy, pokud tak bylo
          stanoveno evropským nebo národním zákonodárným orgánem v právních
          nařízeních, zákonech nebo jiných předpisech Evropské unie, kterým
          správce podléhá a po dobu trvání veškerých promlčecích lhůt nároků
          souvisejících s Robotics.
        </p>
      </div>

      <div className="mt-40">
        <h2>III. Poskytování platformy</h2>

        <h3>1. Popis a rozsah zpracování osobních údajů</h3>
        <p>
          Při každém vyvolání naší platformy náš systém automaticky shromažďuje
          údaje a informace z počítačového systému vyvolávajícího počítače.
        </p>

        <p className="mt-10">Jsou přitom shromažďovány tyto údaje:</p>

        <ul>
          <li>datum a čas požadavku</li>
          <li>název požadovaného souboru</li>
          <li>čas posledního přihlášení</li>
          <li>stránka, ze které byl soubor vyžádán</li>
          <li>stav přístupu (soubor přenesen, soubor nenalezen atd.)</li>
          <li>použitý webový prohlížeč a použitý operační systém</li>
          <li>úplná IP adresa žádajícího počítače</li>
          <li>objem přenesených dat</li>
          <li>data o robotu, informace routeru k robotu a karty robotu</li>
        </ul>

        <p>Údaje jsou ukládány i do souborů protokolu našeho systému.</p>

        <h3>2. Právní základ pro zpracování osobních údajů</h3>
        <p>
          Jako právní základ pro dočasné uložení údajů a souborů protokolu
          slouží čl. 6 odst. 1 písm. f) GDPR.
        </p>

        <h3>3. Účel zpracování osobních údajů</h3>
        <p>
          Dočasné uložení IP adresy systémem je nezbytné k tomu, aby bylo
          umožněno otevření platformy v počítači uživatele. Za tímto účelem musí
          zůstat IP adresa uživatele uložena po celou dobu trvání relace.
        </p>

        <p className="mt-10">
          Ukládání do souborů protokolu je prováděno proto, aby byla zajištěna
          funkčnost platformy. Kromě toho nám tyto údaje slouží k optimalizaci
          platformy a k zajištění bezpečnosti našich IT systémů.
        </p>

        <p className="mt-10">
          V těchto účelech také spočívá náš oprávněný zájem při zpracování údajů
          v souladu s čl. 6 odst. 1 písm. f) GDPR.
        </p>

        <h3>4. Doba uchovávání údajů</h3>
        <p>
          Správce uchovává osobní údaje nejdéle po dobu 60 dnů od jejich
          získání, po uplynutí této doby dojde k jejich výmazu.
        </p>
      </div>

      <div className="mt-40">
        <h2>IV. Registrace na platformě</h2>

        <h3>1. Popis a rozsah zpracování osobních údajů</h3>
        <p>
          Aby bylo možné platformu komplexně využívat a získávat strojová data
          zpracovaná pro příslušné registrované zařízení, je povinná registrace
          na platformě a registrace uživatelského účtu.
        </p>

        <p className="mt-10">
          Není-li uvedeno jinak, zpracováváme vaše osobní údaje jako uživatele
          naší platformy (dále jen: dotčená osoba) za tím účelem, abychom vám
          mohli poskytnout účet Kärcher Professional, jehož pomocí se můžete
          přihlásit na různé portály pro oblast Professional. Za účelem
          registrace účtu Kärcher Professional zpracováváme tyto osobní údaje:
        </p>

        <p className="mt-10">uživatelské jméno</p>

        <ul>
          <li>heslo</li>
          <li>adresa</li>
          <li>oslovení</li>
          <li>jméno</li>
          <li>obchodní e-mail</li>
          <li>obchodní telefonní číslo</li>
        </ul>

        <p className="mt-10">
          Založení účtu Kärcher Professional je pro používání chráněné oblasti
          nezbytné. Používání obsahu (přihlašovací oblast) chráněného žádostí o
          registraci není bez zadání osobních údajů možné. Pokud chcete naši
          přihlašovací oblast používat, musíte vyplnit údaje označené jako
          povinné a vytvořit si uživatelský účet.
        </p>

        <p className="mt-10">
          Registrace uživatelského účtu probíhá prostřednictvím účtu Kärcher
          Professional, ve kterém si příslušný uživatel může zvolit heslo (dále
          jen &quot;uživatelské údaje&quot;) spolu se svou e-mailovou adresou.
          Tyto údaje jsou pro registraci a následné používání účtu Kärcher
          Professional nezbytné. Kromě toho lze dobrovolně uvést další informace
          (např. název společnosti a kontaktní údaje). Údaje se zadávají do
          vstupní masky, přenášejí se k nám a ukládají se v naší databázi.
        </p>

        <p className="mt-10">
          Na platformě lze uložit telefonní čísla a e-mailové adresy pro
          přeposílání zpráv SMS nebo e-mailů odeslaných ze zařízení. Tyto údaje
          se ukládají jako tzv. operátoři, kde je uloženo jméno, telefonní
          číslo, e-mailová adresa a příslušné zařízení, ze kterého jsou zprávy
          přeposílány.
        </p>

        <h3>2. Právní základ pro zpracování osobních údajů</h3>
        <p>
          Při zpracování osobních údajů slouží jako právní základ splnění
          smlouvy, jíž jste stranou (čl. 6 odst. 1 písm. b) GDPR). Zpracování
          osobních údajů pro účely vymáhání případných právních nároků v
          souvislosti s uživatelským účtem na platformě je prováděno na základě
          našeho oprávněného zájmu dle čl. 6 odst. 1 písm. f) GDPR.
        </p>

        <h3>3. Účel zpracování osobních údajů</h3>
        <p>
          Vytvoření uživatelského účtu je nezbytné pro přiřazení k příslušnému
          zařízení nebo pro používání poskytovaných funkcí. Údaje mohou být
          zpracovány také při použití funkcí zvolených uživatelem.
        </p>

        <h3>4. Doba uchovávání údajů</h3>
        <p>
          Pokud si založíte uživatelský účet, budeme uvedené osobní údaje
          zásadně uchovávat po dobu, po kterou bude účet založen, nebo po kterou
          nebudou v uživatelském účtu změněny nebo vymazány. Po výmazu účtu jsme
          oprávněni vaše osobní údaje zpracovávat po dobu běhu promlčecích lhůt
          dle příslušných právních předpisů pro účely vymáhání jakýchkoliv
          vašich nebo našich nároků.
        </p>

        <p className="mt-10">
          Upozorňujeme, že vymazání příslušného uživatelského účtu na platformě
          může mít za následek ztrátu přístupu k platformě a přístupu k uloženým
          údajům.
        </p>

        <h3>5. Možnost změny či výmazu osobních údajů</h3>
        <p>
          Uživatelé platformy mají možnost kdykoli změnit uložené osobní údaje
          nebo je sami vymazat.
        </p>

        <p className="mt-10">
          Pokud jsou údaje potřebné pro plnění smlouvy nebo pro provedení
          předsmluvních opatření, je možné údaje předčasně vymazat pouze v
          případě, že vymazání nebrání smluvní nebo zákonné povinnosti.
        </p>
      </div>

      <div className="mt-40">
        <h2>V. Používání souborů cookies</h2>

        <h3>1. Popis a rozsah zpracování osobních údajů</h3>
        <p>
          Naše platforma používá soubory cookie. Soubory cookie jsou textové
          soubory, které jsou uloženy v internetovém prohlížeči, resp.
          internetovým prohlížečem v počítačovém systému uživatele. Vyvolá-li
          uživatel platformu, může být v jeho operačním systému uložen soubor
          cookie. Tento soubor cookie obsahuje charakteristický řetězec znaků,
          který umožňuje jednoznačnou identifikaci prohlížeče při opětovném
          vyvolání platformy.
        </p>

        <h3>2. Právní základ pro zpracování osobních údajů</h3>
        <p>
          Jako právní základ pro zpracování osobních údajů za použití funkčně
          nebo technicky nezbytných souborů cookie slouží čl. 6 odst. 1 písm. f)
          GDPR.
        </p>

        <h3>3. Účel zpracování osobních údajů</h3>
        <p>
          Účelem používání technicky nezbytných souborů cookie je zajistit plnou
          funkčnost platformy a zjednodušit používání platformy pro uživatele.
          Některé funkce naší platformy nemohou být bez použití souborů cookie
          nabízeny. Uživatelské údaje shromážděné pomocí technicky nezbytných
          souborů cookie nejsou používány k vytváření uživatelských profilů. V
          těchto účelech také spočívá náš oprávněný zájem při zpracování
          osobních údajů v souladu s čl. 6 odst. 1 písm. f) GDPR.
        </p>

        <h3>4. Možnost deaktivovat cookies</h3>
        <p>
          Soubory cookie jsou ukládány v počítači uživatele a z tohoto počítače
          jsou přenášeny na naše stránky. Jako uživatel tak také máte plnou
          kontrolu nad používáním souborů cookie. Změnou nastavení ve vašem
          internetovém prohlížeči můžete přenos souborů cookie deaktivovat nebo
          omezit. Již uložené soubory cookie mohou být kdykoli vymazány. Může to
          být provedeno i automaticky. Pokud budou soubory cookie pro naši
          platformu deaktivovány, nebude již pravděpodobně možné používat
          všechny funkce platformy v plném rozsahu.
        </p>
      </div>

      <div className="mt-40">
        <h2>VI. Předávání třetím osobám</h2>

        <p>
          V rámci skupiny Kärcher může dojít k internímu zpracování osobních
          údajů, pokud je to nezbytné pro realizaci smlouvy nebo provedení
          předsmluvních opatření v souladu s čl. 6 odst. 1 písm. b) GDPR nebo
          pokud existuje oprávněný zájem na předání v rámci skupiny v souladu s
          čl. 6 odst. 1 písm. f) GDPR.
        </p>

        <p className="mt-10">
          Kromě případů výslovně uvedených v tomto prohlášení o ochraně osobních
          údajů mohou vaše osobní údaje bez vašeho výslovného předchozího
          souhlasu být předány třetím osobám pouze tehdy, pokud to povoluje,
          resp. vyžaduje zákon. To zahrnuje i předání (na výzvu) orgánům činným
          v trestním řízení a soudům.
        </p>

        <p className="mt-10">
          Bude-li to za účelem objasnění nezákonného, resp. neoprávněného
          používání platformy nebo za účelem právního stíhání nutné, budou
          osobní údaje předány orgánům činným v trestním řízení nebo jiným
          orgánům a případně poškozeným třetím osobám. K tomu však dojde pouze
          tehdy, pokud existují důkazy pro nezákonné, resp. neoprávněné chování.
        </p>

        <p className="mt-10">
          Případné předání osobních údajů je opodstatněné tím, že (1) zpracování
          je nezbytné pro splnění právní povinnosti, které v souladu s čl. 6
          odst. 1 písm. c) GDPR ve spojení s národními právními předpisy
          týkajícími se předání údajů orgánům činným v trestním řízení
          podléháme, nebo že (2) máme oprávněný zájem na předání údajů výše
          uvedeným třetím osobám, pokud existují důkazy pro neoprávněné chování
          nebo za účelem vymáhání právních nároků, a vaše práva a zájmy na
          ochranu vašich osobních údajů ve smyslu čl. 6 odst. 1 písm. f) GDPR
          nepřevažují.
        </p>

        <p className="mt-10">
          Aby bylo možné služby na této platformě nabízet, jsou využívány
          externí poskytovatelé služeb, zejména poskytovatelé IT služeb.
          Případně využívaní externí poskytovatelé služeb jsou v rámci čl. 28
          odst. 1 GDPR pečlivě vybíráni jako zpracovatelé, pravidelně
          kontrolováni a smluvně zavázáni zpracovávat veškeré osobní údaje
          výhradně v souladu s našimi pokyny.
        </p>
      </div>

      <div className="mt-40">
        <h2>VII. Předávání údajů do třetích zemí</h2>

        <p>
          Není-li uvedeno jinak, jsou údaje do zemí mimo Evropskou unii
          (takzvané třetí země) předávány pouze tehdy, pokud
        </p>

        <ul>
          <li>
            je to nezbytné k provedení vašich příkazů (např. platební příkazy),
          </li>
          <li>to slouží ke zlepšení produktu,</li>
          <li>je zajištěna odpovídající úroveň ochrany osobních údajů nebo</li>
          <li>jste nám udělili svůj souhlas.</li>
        </ul>
      </div>

      <div className="mt-40">
        <h2>VIII. Zabezpečení dat</h2>

        <h3>1. Všeobecná technicky organizační opatření</h3>
        <p>
          Společnost Kärcher učinila celou řadu bezpečnostních opatření, aby
          osobní informace chránila v odpovídajícím rozsahu a přiměřeně. Všechny
          údaje uložené společností Kärcher jsou chráněny fyzickými, technickými
          a procesními opatřeními, která přístup k informacím v souladu s tímto
          prohlášením o ochraně osobních údajů omezují na speciálně autorizované
          osoby.
        </p>

        <h3>2. Bezpečný přenos dat</h3>
        <p>
          Přenos vašich osobních údajů v rámci procesu objednávky je šifrován
          pomocí standardní technologie Secure Socket Layer („SSL“), verze
          šifrování SSL nebo srovnatelných technologií.
        </p>

        <h3>3. Hesla</h3>
        <p>
          Své heslo pro přístup na naši platformu byste nikdy neměli sdělovat
          třetím osobám a měli byste ho pravidelně měnit. Pokud chcete opustit
          svůj uživatelský účet, měli byste stisknout tlačítko pro odhlášení a
          zavřít prohlížeč, abyste zabránili neoprávněnému přístupu k účtu.
        </p>
      </div>

      <div className="mt-40">
        <h2>IX. Práva dotčené osoby (subjektu údajů)</h2>

        <h3>1. Právo na informace</h3>
        <p>
          V souladu s čl. 15 GDPR si můžete vyžádat informace o tom, zda vaše
          osobní údaje zpracováváme. Pokud vaše osobní údaje zpracováváme, máte
          právo na bezplatné poskytnutí kopie těchto osobních údajů. Poskytnutí
          další kopie vyžádané dotčenou osobou mohou podléhat poplatku
          odpovídajícímu administrativním nákladům spojeným s takovým
          poskytnutím.
        </p>

        <h3>2. Právo na opravu</h3>
        <p>
          Pokud informace, které se vás týkají, (již) nejsou správné, můžete v
          souladu s čl. 16 GDPR požádat o jejich opravu. Pokud jsou vaše údaje
          neúplné, můžete požádat o jejich doplnění.
        </p>

        <h3>3. Právo na výmaz</h3>
        <p>
          V souladu s čl. 17 GDPR můžete požádat o vymazání vašich osobních
          údajů. Máte právo žádat o výmaz vašich osobních údajů zejména v těchto
          případech:
        </p>

        <ol type="a">
          <li>
            osobní údaje již nejsou potřebné pro účely, pro které byly
            shromážděny nebo jinak zpracovány;
          </li>
          <li>
            odvoláte souhlas, na jehož základě byly osobní údaje zpracovány, a
            neexistuje žádný další právní důvod pro jejich zpracování;
          </li>
          <li>
            vznesete námitky proti zpracování a neexistují žádné převažující
            oprávněné důvody pro zpracování nebo subjekt údajů vznese námitky
            proti zpracování osobních údajů pro účely oprávněného zájmu;
          </li>
          <li>osobní údaje jsou zpracovávány protiprávně;</li>
          <li>
            osobní údaje musí být vymazány ke splnění právní povinnosti
            stanovené právem Evropské unie nebo členského státu, které se na nás
            vztahuje;
          </li>
          <li>
            osobní údaje dítěte byly shromážděny v souvislosti s nabídkou služeb
            informační společnosti učiněnou přímo dítěti.
          </li>
        </ol>

        <h3>4. Právo na omezení zpracování</h3>
        <p>
          V souladu s čl. 18 GDPR máte právo požádat o omezení zpracování vašich
          osobních údajů, a to v těchto případech:
        </p>

        <ol type="a">
          <li>
            popíráte přesnost osobních údajů (v tomto případě bude zpracování
            omezeno na dobu potřebnou k tomu, abychom mohli přesnost osobních
            údajů ověřit);
          </li>
          <li>
            zpracování osobních údajů je protiprávní, odmítáte výmaz osobních
            údajů a žádáte místo toho o omezení jejich použití;
          </li>
          <li>
            vaše osobní údaje již nepotřebujeme pro stanovený účel zpracování,
            ale vy je požadujete pro určení, výkon nebo obhajobu právních
            nároků;
          </li>
          <li>
            vznesl/a jste námitku proti zpracování vašich osobních údajů (v
            tomto případě bude zpracování vašich osobních údajů omezeno, dokud
            nebude ověřeno, zda naše oprávněné důvody převažují nad oprávněnými
            důvody subjektu údajů).{' '}
          </li>
        </ol>

        <h3>5. Právo na stížnost</h3>
        <p>
          Pokud se domníváte, že zpracování vašich osobních údajů porušuje zákon
          o ochraně osobních údajů, máte v souladu s čl. 77 odst. 1 GDPR právo
          podat stížnost u Úřadu pro ochranu osobních údajů, Pplk. Sochora 27,
          Praha 7, PSČ 170 00, Česká republika, www.uoou.cz.
        </p>

        <h3>6. Právo na přenositelnost údajů</h3>
        <p>
          V případě, že jsou splněny předpoklady čl. 20 odst. 1 GDPR, máte právo
          na to, abychom údaje, které automatizovaně zpracováváme na základě
          vašeho souhlasu nebo v rámci plnění smlouvy, předali vám nebo třetím
          osobám. Osobní údaje vám poskytneme ve strukturovaném, běžně
          používaném a strojově čitelném formátu. Získané osobní údaje jste
          oprávněn/a předat jinému správci osobních údajů. Je na vás, abyste si
          zvolil/a, zda máme vaše osobní údaje poskytnout přímo vám nebo zda
          máme vaše osobní údaje předat přímo jinému správci, je-li to technicky
          proveditelné.
        </p>

        <h3>7. Právo vznést námitku v souladu s čl. 21 odst. 1 GDPR</h3>
        <p>
          Máte právo vznést námitku z důvodů, týkajících se vaší konkrétní
          situace, proti zpracování vašich osobních údajů, které je prováděno na
          základě čl. 6 odst. 1 písm. f) GDPR, tj. na základě našeho oprávněného
          zájmu. Správce již poté osobní údaje nezpracovává, pokud neprokáže
          závažné oprávněné důvody pro zpracování, které převažují nad zájmy,
          právy a svobodami dotčené osoby, nebo pokud zpracování neslouží pro
          určení, výkon nebo obhajobu právních nároků.
        </p>
      </div>

      <div className="mt-40">
        <h2>X. Změny tohoto prohlášení o ochraně osobních údajů</h2>

        <p>
          Toto prohlášení o ochraně osobních údajů udržujeme v aktuálním znění.
          Proto si vyhrazujeme ho čas od času aktualizovat, upravovat a změny
          při zpracování nebo užívání vašich dat spravovat. Aktuální znění
          prohlášení o ochraně osobních údajů vždy naleznete pod „prohlášení o
          ochraně osobních údajů“ na naší platformě.
        </p>
      </div>
    </>
  );
}
